import { render, staticRenderFns } from "./RevenueStatisticsList.vue?vue&type=template&id=fa665488&"
import script from "./RevenueStatisticsList.ts?vue&type=script&lang=js&"
export * from "./RevenueStatisticsList.ts?vue&type=script&lang=js&"
import style0 from "./RevenueStatisticsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports